import React from 'react';
import { useNavigate } from 'react-router-dom';

const Breadcrumb = ({ items, onNavigate }) => {
  const navigate = useNavigate();

  const handleNavigate = (item, index) => {
    if (onNavigate) {
      onNavigate(item, index);
    } else {
      if (item.path) {
        navigate(item.path);
      }
    }
  };

  return (
    <nav aria-label="breadcrumb">
      <ol className="lh-1-85 breadcrumb">
        {items.map((item, index) => (
          <li
            key={index}
            className={`breadcrumb-item ${index === items.length - 1 ? 'active' : ''}`}
          >
            {index === items.length - 1 ? (
              <span>{item.label}</span>
            ) : (
              <a
                href="javascript:void(0);"
                onClick={(e) => {
                  e.preventDefault();
                  handleNavigate(item, index);
                }}
              >
                {item.label}
              </a>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
